import { regions } from "@/utils/locales";
import { ArrowRight, MapPin } from "lucide-react";

import { cityTransportUrl } from "@/utils/urls";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";

interface City {
  number?: number;
}

export const CidadesSection = ({ number = 18 }: City) => {
  const allCities = regions.flatMap((region) => region.cities);
  const displayCities = allCities.slice(0, number);

  return (
    <section className=" py-10 md:py-24 bg-white">
      <div className="container">
        <div className="text-center mb-12">
          <h2
            style={{ fontFamily: "'Anton', sans-serif" }}
            className="mb-5 text-n-text-green text-3xl md:mb-6 md:text-6xl lg:text-7xl"
          >
            Envie o seu veículo para{" "}
            <span className="text-n-secondary">qualquer cidade!</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 mb-8">
          {displayCities.map((city) => (
            <Link
              key={city.id}
              to={cityTransportUrl(city.slug)}
              className="group bg-n-bg-2 hover:bg-n-green-h-light border border-n-beige hover:border-n-secondary/20 rounded-lg p-4 transition-all duration-200 hover:shadow-md"
            >
              <div className="flex items-center gap-2 mb-2">
                <MapPin className="h-4 w-4 text-n-text-green" />
                <span className="font-semibold text-n-text group-hover:text-n-text-green transition-colors">
                  {city.name}
                </span>
              </div>

              <div className="text-sm text-gray-600 mb-3">{city.state}</div>

              <div className="flex items-center justify-between">
                <span className="text-sm text-n-text-green font-medium group-hover:text-green-700">
                  Saiba mais
                </span>
                <ArrowRight className="h-4 w-4 text-n-text-green group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>

        {number < allCities.length && (
          <div className="text-center">
            <p className="text-gray-600 mb-4">
              E muito mais! Atendemos mais de 200 cidades em todo o Brasil.
            </p>
            <Link to="/cidades">
              <Button variant="ghost" className="text-n-text-green">
                Ver todas as cidades
                <ArrowRight className="h-4 w-4" />
              </Button>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};
